import * as Sentry from '@sentry/vue'
import axios from 'axios'
import {AlertMessages, ErrorCodes} from '@/lib/definitions'
import auth from '@/lib/auth'

let api = {}

api.init = () => {
  api.tokenRenewedAt = null
  axios.defaults.baseURL = process.env.VUE_APP_API_URL
  axios.defaults.headers.post['Content-Type'] = 'application/json'
  axios.defaults.headers.common['Authorization'] = '' // Set in ...
}

api.setAuthToken = token => {
  // https://auth0.com/docs/tokens/access-token
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  api.tokenRenewedAt = new Date()
}

api.call = async (method, resource, params = null, config = null) => {
  await auth.checkToken().catch(e => auth.logout(e.errorDescription || e))
  return axios[method](resource, params, config)
    .then(response => response.data.response)
    .catch(error => {
      // add Sentry logger for test
      Sentry.captureException(error)
      let e = error
      if (error.response) {
        e = error.response.data.response
        // 401 Unauthorized, log user out
        if (error.response.status === 401) {
          let message = AlertMessages.TOKEN_INVALID
          if (e.devCode === ErrorCodes.TOKEN_EXPIRED) {
            message = AlertMessages.TOKEN_EXPIRED
          }
          auth.logout(message)
        }
      } else if (e.isAxiosError) {
        // https://github.com/axios/axios/pull/1419
        e = new Error(AlertMessages.NETWORK_ERROR)
        e.devCode = 0
        e.devMessage = AlertMessages.NETWORK_ERROR
      }
      // TODO: Fallback
      console.error('API error =>', resource, e)
      return Promise.reject(e)
    })
}

export default api
